import {Component, Input} from '@angular/core';

@Component({
    selector: 'af-action-panel',
    templateUrl: 'action-panel.component.html',
    styleUrls: ['action-panel.component.scss'],
    standalone: false
})
export class ActionPanelComponent {
    @Input() viewModel: PanelViewModel;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() icon: string;

    isHover = false;
}

export interface PanelViewModel {
    title: string;
    subtitle: string;
    disabledTitle?: string;
    badgeTitle?: string;
    icon: string;
    click?: () => void;
    disabled?: boolean;
}
